import * as React from "react";
import { TextInput, TextStyle } from "react-native";
import Animated from "react-native-reanimated";

const { Value, concat } = Animated;
const AnimatedTextInput = Animated.createAnimatedComponent(TextInput);

export { Value };
export type Value = typeof Value;

export { concat };
export type Node = ReturnType<typeof concat>;

interface TextProps {
  text: Node;
  style?: TextStyle;
}

export default (props: TextProps) => {
  const { text, style } = { style: {}, ...props };
  return (
    <AnimatedTextInput
      underlineColorAndroid="transparent"
      editable={false}
      {...{ text, style }}
    />
  );
};
